import React, { useState, useContext } from "react";
import { globalInfo } from "../../App";
import { Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import { submitFormData } from "../../Utils/adminFunctions";
import * as Constant from "../../Utils/constants";
import isEmail from "validator/lib/isEmail";
const AddAdministratorUser = () => {
  const { ip_address } = useContext(globalInfo);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState("");
  const [department, setDepartment] = useState("");
  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [errorUserType, setErrorUserType] = useState("");
  const [errorDepartment, setErrorDepartment] = useState("");
  const handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim();
    const passwordLength = passwordInputValue.length;
    const uppercasePassword = Constant.UPPERCASE.test(passwordInputValue);
    const lowercasePassword = Constant.LOWERCASE.test(passwordInputValue);
    const digitsPassword = Constant.DIGITS.test(passwordInputValue);
    const specialCharPassword = Constant.SPECIALCHAR.test(passwordInputValue);
    const minLengthPassword = Constant.MINLENGTH.test(passwordInputValue);
    let errMsg = "";
    if (passwordLength === 0) {
      errMsg = "Password is empty";
    } else if (!uppercasePassword) {
      errMsg = "At least one Uppercase";
    } else if (!lowercasePassword) {
      errMsg = "At least one Lowercase";
    } else if (!digitsPassword) {
      errMsg = "At least one digit";
    } else if (!specialCharPassword) {
      errMsg = "At least one Special Characters";
    } else if (!minLengthPassword) {
      errMsg = "At least minumum 8 characters";
    }
    setErrorPassword(errMsg);
  };
  let handleSubmit = () => {
    let errorRequiredFiled = 0;
    if (firstName === "") {
      setErrorFirstName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (lastName === "") {
      setErrorLastName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (email === "") {
      setErrorEmail("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (password === "") {
      setErrorPassword("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (userType === "") {
      setErrorUserType("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (department === "") {
      setErrorDepartment("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }

    if (isEmail(email) === false) {
      setErrorEmail("Incorrect email format");
      toast.warning("Incorrect email format ", { autoClose: 1500 });
      return false;
    }

    const bodyFormData = new FormData();
    bodyFormData.append("first_name", firstName);
    bodyFormData.append("last_name", lastName);
    bodyFormData.append("email", email);
    bodyFormData.append("password", password);
    bodyFormData.append("user_type", userType);
    bodyFormData.append("department", department);
    bodyFormData.append("entered_by_ip", ip_address);

    async function fetchAPI2() {
      const response = await submitFormData(
        "addAdministratorUser",
        bodyFormData
      );
      if (response.status == "success") {
        setFirstName("");
        setLastName("");
        setEmail("");
        setPassword("");
        setUserType("");
        setDepartment("");
        toast.success(response.message, { autoClose: 1500 });
      }
      if (response.status == "failure") {
        toast.warning(response.message, { autoClose: 1500 });
      }
      if (response.status == "error") {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI2();
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to={"/ManageAdministratorUser/"}
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                First Name<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorFirstName ? " is-invalid" : "")
                                }
                                value={firstName}
                                onChange={(e) => {
                                  setFirstName(e.target.value);
                                  setErrorFirstName("");
                                }}
                                placeholder="First Name"
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Last Name<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorLastName ? " is-invalid" : "")
                                }
                                value={lastName}
                                placeholder="Last Name"
                                onChange={(e) => {
                                  setLastName(e.target.value);
                                  setErrorLastName("");
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Email<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorEmail ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                  setErrorEmail("");
                                }}
                                value={email}
                                placeholder="Email"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Password<i className="text-danger">*</i>
                              </span>
                              <input
                                type="password"
                                className={
                                  "form-control" +
                                  (errorPassword ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setPassword(e.target.value);
                                  setErrorPassword("");
                                }}
                                onKeyUp={handleValidation}
                                value={password}
                                placeholder="Password"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Department<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control custom-select" +
                                  (errorDepartment ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setDepartment(e.target.value);
                                  setErrorDepartment("");
                                }}
                                value={department}
                              >
                                <option value="">Select</option>
                                <option value="MPH">MPH</option>
                                <option value="QRC">QRC</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                User Type<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control custom-select" +
                                  (errorUserType ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setUserType(e.target.value);
                                  setErrorUserType("");
                                }}
                                value={userType}
                              >
                                <option value="">Select</option>
                                <option value="4">Sub Admin</option>
                                <option value="5">Quality Supervisor</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <button
                              type="button"
                              className="btn btn-sm custom-btn-primary pull-right"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AddAdministratorUser;
